module.exports = __webpack_public_path__ + "img/fwzt02_1.866a163.png";